var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCustomPreset24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "square",
  strokeWidth: 1.5,
  d: "M7 3.75V7m0 0v3.25M7 7H3.75M7 7h3.25m9.048 7.702L17 17m0 0-2.298 2.298M17 17l-2.298-2.298M17 17l2.298 2.298M17 10.25a3.25 3.25 0 1 1 0-6.5 3.25 3.25 0 0 1 0 6.5Zm-13.25 3.5h6.5v6.5h-6.5z"
})));
export default SvgCustomPreset24;